import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { DUPLICATE_SURVEY } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { DuplicateSurveyDataActionTypes } from './types';
import api from 'src/utils/api';

export const loadDuplicateSurvey =
  (
    id: number | string,
  ): ThunkAction<Promise<void>, State, null, DuplicateSurveyDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: DUPLICATE_SURVEY + REQUEST });
    try {
      const payload = await api.loadDuplicateSurvey(id);
      dispatch({ type: DUPLICATE_SURVEY + SUCCESS, payload });
    } catch (error) {
      dispatch({ type: DUPLICATE_SURVEY + FAILURE, error });
    }
  };

export const duplicateSurveyIdle = () => ({
  type: DUPLICATE_SURVEY + IDLE,
});
